import React from "react";
import { MarkdownContent } from "utils/markdown/markdown-content";

export const TermsOfUse = () =>  <MarkdownContent path={require("../content/terms-of-use.md")} title="Terms of Use" />;

